import { render, staticRenderFns } from "./FireClaimList.vue?vue&type=template&id=db88db4c&"
import script from "./FireClaimList.vue?vue&type=script&lang=js&"
export * from "./FireClaimList.vue?vue&type=script&lang=js&"
import style0 from "./FireClaimList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireClaimList.vue"
export default component.exports